import React from 'react';
import { Modal } from './Modal';
import { cancelRemoveSystem } from '../actions';
import { AppDispatch } from '../../schematic/reducer';
import { removeSystem } from '../../schematic/actions';
import { translationService } from '../../services/translationService';

export interface RemoveSystemModalProps {
  dispatch: AppDispatch;
  systemId: string | null;
}

export const RemoveSystemModal: React.FC<RemoveSystemModalProps> = ({ dispatch, systemId }) => {
  return (
    <Modal
      header={<div>{translationService.getTranslation('deleteSystem')}</div>}
      body={<p className="modal-delete-text">{translationService.getTranslation('confirmDeleteSystem')}</p>}
      actions={
        <React.Fragment>
          <button slot="actions" onClick={() => dispatch(cancelRemoveSystem())}>
            {translationService.getTranslation('back')}
          </button>
          {systemId && (
            <button slot="actions" onClick={() => dispatch(removeSystem({ systemId }))} style={{ color: '#d5000f' }}>
              {translationService.getTranslation('deleteSystem')}
            </button>
          )}
        </React.Fragment>
      }
      onBackdropClick={() => dispatch(cancelRemoveSystem())}
    />
  );
};
